import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import axios from 'axios'
// 引入ECharts主模块
import echarts from 'echarts'
import VueQuillEditor from 'vue-quill-editor'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;



import videojs from 'video.js'
Vue.prototype.$videoJS = videojs;






// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 使用插件



// function setHtmlFontSize() {
//   const html = document.documentElement;
//   html.style.fontSize = '100px';
// }
// setHtmlFontSize();
Vue.use(ElementUI, {
  locale
})
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = window.echarts
Vue.use(VueQuillEditor /* { default global options } */)



new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js